import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_code: "HAND = 0 #グーを出す",
    user_title: "",
    enemy_code:"HAND = 1 # チョキを出す",
    enemy_id:"",
    enemy_title:"",
    jankenHistory:{win:0,lose:0,drow:0},
    user: {},
    status: false
  },
  mutations: {
    onAuthStateChanged(state, user) {
      state.user = user; //firebaseが返したユーザー情報
    },
    onUserStatusChanged(state, status) {
      state.status = status; //ログインしてるかどうか true or false
    },
    setUserTitle(state,title){
      state.user_title = title
    },
    setUserCode(state,code){
      state.user_code = code
    },
    setEnemyCode(state,code){
      state.enemy_code = code
    },
    setEnemyId(state,id){
      state.enemy_id = id
    },
    setEnemyTitle(state,title){
      state.enemy_title = title
    },
    
    setJankenHistory(state, history) {
      state.jankenHistory = history; //firebaseが返したユーザー情報
    },
    onAuthStateChanged(state, user) {
      state.user = user; //firebaseが返したユーザー情報
    },
  },
  getters: {
    user(state) {
      return state.user;
    },
    isSignedIn(state) {
      return state.status;
    }
  }
});